export const getJobData = (state, jobId) => state.getIn(['ui', 'entityStack', 'exports', 'jobs', jobId], {})
